<template>
  <v-card>
    <v-toolbar card flat dark dense color="primary">
      <v-toolbar-title>{{ title }}</v-toolbar-title>
    </v-toolbar>
    <v-card-text class="pa-0">
      <v-list two-line subheader>
        <template v-for="(item, index) in items">
          <v-divider v-if="index" :key="item._id + index" inset />

          <v-list-tile :key="item._id" avatar>
            <v-list-tile-avatar v-if="item.userPhoto">
              <img :src="item.userPhoto" />
            </v-list-tile-avatar>

            <v-list-tile-content>
              <v-list-tile-title v-if="item.userName">
                {{ item.userName + ' ' + item.userLastname }}
              </v-list-tile-title>
              <v-list-tile-sub-title class="caption gray--text text--lighten-1">
                <template v-if="item.position != 'noPositionSpecified'">
                  <span>{{ item.position || '--' }}</span>
                  <span>|</span>
                </template>
                <template v-if="convocation && item.convocation">
                  <span>{{
                    $t(`fields.teams.convocations.${item.convocation}`)
                  }}</span>
                  <span>|</span>
                </template>
                <span>{{
                  `${$t('fields.global.dorsal')}: ${
                    item.dorsal || item.dorsal === 0 ? item.dorsal : '--'
                  }`
                }}</span>
              </v-list-tile-sub-title>
            </v-list-tile-content>
            <v-list-tile-action v-if="edit">
              <!-- <v-layout wrap row>
                <v-flex d-flex> -->
              <v-icon small color="success" @click="$emit('setLineUp', item)">
                edit
              </v-icon>
              <v-icon
                v-if="item.position != 'noPositionSpecified'"
                small
                color="error"
                @click="ifDelete(item._id)"
              >
                delete
              </v-icon>
              <!-- </v-flex>
              </v-layout> -->
            </v-list-tile-action>
          </v-list-tile>
        </template>
      </v-list>
    </v-card-text>
    <dialog-delete
      :dialog.sync="dialogDelete"
      :loading="loadingDelete"
      @delete="_deleteLineUp"
    />
  </v-card>
</template>

<script>
import DialogDelete from '@/components/widgets/dialog/DialogDelete'
export default {
  name: 'LineUpList',
  components: { DialogDelete },
  props: {
    title: {
      type: String,
      required: true,
      default: '',
    },
    items: {
      type: Array,
      required: true,
      default: () => [],
    },
    matchId: {
      type: String,
      required: false,
      default: '',
    },
    teamType: {
      type: String,
      required: false,
      default: 'home',
    },
    teamId: {
      type: String,
      required: true,
      default: '',
    },
    convocation: {
      type: Boolean,
      required: false,
      default: true,
    },
    actions: {
      type: Object,
      required: true,
      default: () => ({}),
    },
    edit: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
  data() {
    return {
      dialogDelete: false,
      loadingDelete: false,
      idDelete: '',
    }
  },
  methods: {
    ifDelete(id) {
      this.idDelete = id
      this.dialogDelete = true
    },
    _deleteLineUp() {
      let payload = { lineUpId: this.idDelete }

      if (this.matchId) {
        payload.matchId = this.matchId
        payload.teamType = this.teamType
      } else if (this.teamId) {
        payload.teamId = this.teamId
      } else return
      this.actions.deleteLineUp &&
        this.actions.deleteLineUp(payload).finally(() => {
          this.dialogDelete = false
          this.idDelete = ''
        })
    },
  },
}
</script>
